(function(){
'use strict';

angular.module('classy').component('panelSection', {
  template: '<section class="panel__section" data-ng-transclude></section>',
  transclude: true
});
})();